module.exports = __webpack_public_path__ + "resources/icon_50_close.883bb5aa2842b141.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_close.png
// module id = 440
// module chunks = 0 1 2 3 4